import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file useUncontrolled 判断是否可控状态
 */
import { useRef, useState } from 'react';
import { useRefCallback } from './useRefCallback';
export function useUncontrolled(controlled, fallback, value, defaultValue, onChange, propsName) {
  var controlledRef = useRef(controlled);
  var onChangeCallback = useRefCallback(onChange);

  if (controlled !== controlledRef.current) {
    console.warn('Warning: ' + 'you should not switch `' + (propsName || 'props') + '` from uncontrolled to controlled (or vice versa). ' + 'Decide between using controlled props or uncontrolled props for the lifetime of this component');
  }

  var _useState = useState(function () {
    return defaultValue !== undefined ? defaultValue : fallback;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      innerValue = _useState2[0],
      setInnerValue = _useState2[1];

  if (controlledRef.current) {
    return [value !== undefined ? value : fallback, onChangeCallback];
  }

  return [innerValue, setInnerValue];
}